import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import BottomSheetOption from './BottomSheetOption';
import { openAlert } from '../store/actions/alert';
import { i18nNS } from '../i18n';
import { chargeActions, EXPENSE_SUB_TAB_OPTIONS } from '../constants/Enums';
import { performChargesAction } from '../services/api/expense.service';
import { Modals } from '../constants/ScreenNames';

const ChargeOptions = ({
  selectedCharge,
  forceUnSetSelectedCharge,
  expenseChargesRef,
  fromExistingReport = false,
}) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { t } = useTranslation(i18nNS.tripExpense);

  const removeChargeFromList = (TransactionId) => {
    forceUnSetSelectedCharge();
    expenseChargesRef.current.removeChargeFromList(TransactionId);
  };

  const onBusinessPress = () => {
    navigation.navigate(Modals.CreateExpenseModal, {
      selectedCharge,
      fromExistingReport,
      subTab: EXPENSE_SUB_TAB_OPTIONS.CHARGES,
    });
  };

  const onPersonalPress = () => {
    dispatch(
      openAlert({
        title: 'Thank you for letting us know this is a personal charge.',
        confirmText: 'Confirm',
        showXMark: true,
        cancelText: t('common:Cancel'),
        onConfirmPressed: () => {
          const { TransactionId, FirstSixLastFourCardNumber } = selectedCharge;
          const params = {
            ActionCode: chargeActions.SET_CHARGE_AS_PERSONAL,
            TransactionId,
            FirstSixLastFourCardNumber,
          };
          performChargesAction(params);
          removeChargeFromList(TransactionId);
        },
      })
    );
  };

  return (
    <>
      <BottomSheetOption label="Business" onPress={onBusinessPress} />
      <BottomSheetOption label="Personal" onPress={onPersonalPress} />
    </>
  );
};

export default ChargeOptions;
